import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface PortalProps {
  children: React.ReactNode
}

// Renders children at document.body.
//
// The header wraps its content in a `backdrop-blur` layer, and any element with
// a backdrop-filter/transform/filter becomes the containing block for its
// `position: fixed` descendants. Full-screen surfaces rendered inside the header
// (mobile menu, search overlay) would therefore resolve `inset-0` against the
// header box instead of the viewport. Portalling them out fixes that.
export function Portal({ children }: PortalProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted) return null
  return createPortal(children, document.body)
}
